import { HttpRequest } from '@angular/common/http';
import { InjectionToken } from '@angular/core';


export const INTERCEPTOR_EXCEPT_URL: string[] = [];

export const authTokenInterceptorFilter =
  new InjectionToken<(req: HttpRequest<any>) => boolean>('Interceptor Filter');

export const filterInterceptorRequest = (req: HttpRequest<any>): boolean => {
  return INTERCEPTOR_EXCEPT_URL.some(url => req.url.includes(url));
}


